{
  "qr-checkin-success-page": {
    "buttons": {
      "book-now": "RESERVE MAINTENANT",
      "find-salon": "TROUVER UN SALON",
      "salon-page": "PAGE DE RÉSERVATION DU SALON"
    },
    "text": {
      "checked-in": "Checked in avec succès !",
      "checked-in-hint": "Vous pouvez à tout moment prendre un nouveau rendez-vous pour le traitement suivant"
    },
    "meta": {
      "title": "QR Check in",
      "description": "Check in par code QR"
    }
  }
}
